export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/more-icon.svg?8d6baef8ffbb2a52fbd89039a9b2e8ab";